module.exports = __webpack_public_path__ + "static/a-xx-111-art-1e42860a2412c4f21f28080b8ad50f35.jpg";